import React from "react";
import Label from "components/general/Label"
import DateTime from "components/presentation/DateTime"
import { isLiveStatus, isLessLiveStatus } from "helpers/status";
import Competitor from "components/presentation/Competitor";
import Noc from "components/presentation/Noc";
import Status from "components/presentation/Status";
import { getDateTimeFormat } from "helpers/utils";
import SportCode from "components/common/SportCode";


export function Footer({ data }) {
    const formatDate = getDateTimeFormat('DayMonthShort')
    const formatDateTime = getDateTimeFormat('DayMonthShortHourMinute');
    const dateTime = data?.bi_date + ' ' + data?.bi_time
    const dateTimeFormated = data?.bi_date && <DateTime datetime={dateTime} format={formatDateTime} />
    const date = data?.bi_date && <><DateTime datetime={data?.bi_date} format={formatDate} />, <SportCode entity='@CompetitorPlace' code="TBD" abbr={true} /></>
    const time = data?.bi_time && <DateTime datetime={dateTime} format={"HH:mm"} />
    const dateComponent = data?.bi_time ? dateTimeFormated : date
    const numberGame = data?.bracketItemCode

    return (
        <>
            {isLiveStatus(data?.result?.status?.code) && <div className='score-status justify-content-end'><Status typeToPrint={'result'} scheduleStatus={data?.schedule?.status?.code} resultStatus={data?.result?.status?.code} /></div>}
            <div className="d-flex w-100">
                {isLessLiveStatus(data?.result?.status?.code) && <div className='text-start w-50'>{dateComponent}</div>}
                {isLessLiveStatus(data?.result?.status?.code) && <div className='text-end w-50'><Label data='LabelContest' /> {numberGame}</div>}
            </div>
        </>
    )
}

export function CompetitorBlock(competitor) {
    return (
        <div className='  d-flex flex-row justify-content-start'>
            {/*<div className='score-uniform score-uniform-home'></div>*/}
            <div className='score-noc'>
                <Noc className='me-1' {...competitor?.participant?.organisation} />
            </div>
            <div className=''><Competitor  {...competitor?.participant} hideNoc={true} hidePicture={true} noLink={true} onlyShortName={true} screen={competitor.screen} /></div>
            <div><sup>{competitor?.co_seed && `(${competitor?.co_seed})`}</sup></div>
        </div>
    )
}

